import { useEffect } from 'react'

import { SearchContextState } from '@elastic/react-search-ui/lib/cjs/withSearch'
import { helpers } from '@elastic/search-ui'
import { useQuery } from 'react-query'

import useSubCategoryOptions from 'app/hooks/useSubCategoryOptions'
import { getAttributions } from 'app/services/Api/listing'
import { removeSearchAttributeFilters } from 'app/utils/helpers/elastic.helpers'

const { findFilterValues } = helpers

type UseSearchAttributeFiltersProps = Pick<
  SearchContextState,
  'filters' | 'removeFilter'
> & {
  searchCategoryId?: string
}

const useSearchAttributeFilters = ({
  filters,
  removeFilter,
  searchCategoryId
}: UseSearchAttributeFiltersProps) => {
  const filterCategoryId = findFilterValues(
    filters || [],
    'category_id',
    'any'
  )?.[0] as string
  const subCategoryId = findFilterValues(
    filters || [],
    'sub_category_id',
    'any'
  )?.[0] as string

  const categoryId = filterCategoryId ?? searchCategoryId

  const { isAttributionsPresent } = useSubCategoryOptions({
    categoryId,
    subCategoryId
  })

  const { data: attributions } = useQuery<Attribution[]>(
    [subCategoryId],
    () =>
      getAttributions({
        by_sub_category_id: subCategoryId
      }),
    { enabled: !!subCategoryId && isAttributionsPresent }
  )

  useEffect(() => {
    if (subCategoryId) return

    removeSearchAttributeFilters({ filters, removeFilter })
  }, [subCategoryId])

  return { isAttributionsPresent, attributions }
}

export default useSearchAttributeFilters
